module.exports = __webpack_public_path__ + "img/unit-card-status-charging.92d5ac98.png";